import React from "react";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import RecurringDatePicker from "Payments/Shared/RecurringDatePicker";

export default function RecurringDates() {
  const {
    state: {
      recurringPayment: { startDate, endDate },
      fund: { fundColorSafe },
      paymentParent,
    },
    dispatch,
  } = usePaymentPage();

  const recurringAlwaysOn = paymentParent
    ? paymentParent.recurringAlwaysOn
    : false;

  const setStartDate = (date) => {
    dispatch({
      type: "setStartDate",
      payload: date,
    });
  };

  const setEndDate = (date) => {
    dispatch({
      type: "setEndDate",
      payload: date,
    });
  };

  return (
    <Wrapper $recurringAlwaysOn={recurringAlwaysOn}>
      <RecurringDatePicker
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        accentColor={fundColorSafe}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-left: ${(props) => (props.$recurringAlwaysOn ? 0 : "28px")};

  @media screen and (max-width: 480px) {
    margin-left: 0;
  }
`;
